import { render } from "./OrderBlock.vue?vue&type=template&id=5b23825e&scoped=true"
import script from "./OrderBlock.vue?vue&type=script&lang=js"
export * from "./OrderBlock.vue?vue&type=script&lang=js"

import "./OrderBlock.vue?vue&type=style&index=0&id=5b23825e&scoped=true&lang=scss"

import exportComponent from "/home/romych/projects/vue.home.zina.design/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b23825e"]])

export default __exports__